export default __webpack_public_path__ + "static/media/chatbot.2b8f7589.jpg";